{
  "fr": {
    "dressingRoom": {
      "lead": "Assemblez une armure et une sous-combinaison et voyez la tenue en 3D. Partagez-la par lien ou connectez-vous pour l'enregistrer.",
      "slots": {
        "helmet": "Casque",
        "torso": "Torse",
        "arms": "Bras",
        "legs": "Jambes",
        "backpack": "Sac à dos",
        "undersuit": "Sous-combinaison",
        "primary": "Principale",
        "secondary": "Secondaire",
        "sidearm": "Arme de poing"
      },
      "search": "Rechercher : %{slot}",
      "size": "S%{size}",
      "noResults": "Rien trouvé pour cet emplacement.",
      "choose": "Choisir…",
      "remove": "Retirer",
      "openItem": "Ouvrir la page de l'objet",
      "notFound": "Objet introuvable",
      "noHolo": "Pas encore de modèle 3D",
      "empty": "Choisissez une pièce pour un emplacement pour voir la tenue.",
      "pose": "Pose",
      "copyLink": "Copier le lien",
      "savedOutfits": "Tenues enregistrées",
      "signInToSave": "Connectez-vous pour enregistrer des tenues.",
      "outfitName": "Nom de la tenue",
      "nameTaken": "Vous avez déjà une tenue portant ce nom.",
      "saveNew": "Enregistrer comme nouvelle tenue",
      "saveChanges": "Enregistrer les modifications",
      "noOutfits": "Aucune tenue enregistrée pour l'instant.",
      "pieces": {
        "one": "%{count} pièce",
        "other": "%{count} pièces"
      },
      "confirmDelete": "Supprimer la tenue %{name} ?",
      "messages": {
        "saved": "Tenue enregistrée.",
        "saveFailed": "La tenue n'a pas pu être enregistrée.",
        "deleteFailed": "La tenue n'a pas pu être supprimée.",
        "linkCopied": "Lien copié.",
        "copyFailed": "Le lien n'a pas pu être copié."
      },
      "groups": {
        "armour": "Armure",
        "weapons": "Armes"
      },
      "hold": "Tenir en main",
      "bodies": {
        "male": "Homme",
        "female": "Femme"
      },
      "positionPending": "Position pas encore exportée",
      "fit": {
        "noPort": "%{item} n'a pas d'emplacement pour cela",
        "doesNotFit": "Ne convient pas à %{item}"
      }
    }
  }
}
